import { addToast } from "@caprikorn/dynamo-ui";
import { useMutation } from "@tanstack/react-query";

import { queryClient } from "@/AppQueryClient";
import { useGroupReferences } from "@contexts/GroupReferences/GroupReferences.context";
import { useCustomTranslation } from "@utils/translations/useCustomTranslation";

import { apiEcmsHttp } from "../http";
import { QUERY_KEYS } from "../keys";
import type { User } from "./apiEcms.types";

const deleteUser = (id: string) => apiEcmsHttp.delete<User>(`/users/${id}`);

export const useDeleteUser = () => {
  const { currentGroup } = useGroupReferences();
  const { t } = useCustomTranslation("main");

  return useMutation({
    mutationKey: [QUERY_KEYS.USER_DELETION, currentGroup],
    mutationFn: (id: string) => deleteUser(id),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEYS.USERS, currentGroup],
      });
      addToast({
        variant: "success",
        title: t("userDetails.list.deleteSuccess"),
      });
    },
    onError: () => {
      addToast({
        variant: "error",
        title: t("userDetails.informations.delete.error"),
      });
    },
  });
};
